import { IAutoMapper } from "../interfaces";

export const mapReportingStatusModel = (automapper: IAutoMapper): void => {
  automapper
    .createMap("default", "ReportingStatusModel")
    .forMember("reportingStatusName", o => o.reportingStatusName);
};
